import React from "react";
import styles from './ChoosingUs.module.css';
import experience from '../../assets/home/experience.png';
import communication from '../../assets/home/communication.png';
import comfort from '../../assets/home/comfort.png';

const ChoosingUs = () =>{
    return(
        <div style={{backgroundColor: '#fff1e5'}}>
            <div className="container overflow-hidden">
                <p data-aos='slide-right' data-aos-offset="220" className={styles.heading}>Why AL RIMAL ?</p>
                <p data-aos='slide-left' className={styles.sub_text}>In our financial processes, situations like these may occasionally arise.</p>
                <div className={`row ${styles.sub}`}>
                    <div data-aos='fade-right' className="col-md-4">
                        <img src={experience} alt="Trusted Financial Excellence "/>
                        <p className={styles.logo_head}>Trusted Financial Excellence </p>
                        <p className={styles.logo_text}>Delivering reliable financial solutions with integrity, expertise, and commitment to business success.</p>
                    </div>

                    <div data-aos='fade' className="col-md-4">
                        <img src={communication} alt="experience"/>
                        <p className={styles.logo_head}>Strategic Financial Partners</p>
                        <p className={styles.logo_text}>Providing expert financial guidance and strategic solutions to support sustainable business growth.”</p>
                    </div>

                    <div data-aos='fade-left' className="col-md-4">
                        <img src={comfort} alt="experience"/>
                        <p className={styles.logo_head}>Compliance With Confidence</p>
                        <p className={styles.logo_text}>Ensuring accurate compliance solutions with trusted expertise and professional support.</p>
                    </div>
                    
                </div>
            </div>
        </div>
    )
}

export default ChoosingUs;